import { useState } from "react"
import { Globe } from "lucide-react"

const getSourceHostname = (url) => {
  try {
    return new URL(url).hostname
  } catch {
    return null
  }
}

export function SourceFavicon({ url, name, className = "size-5 rounded-sm" }) {
  const [hasError, setHasError] = useState(false)
  const hostname = getSourceHostname(url)

  if (!hostname || hasError) {
    return (
      <div className={`flex shrink-0 items-center justify-center bg-muted text-muted-foreground ${className}`}>
        <Globe className="size-3" />
      </div>
    )
  }

  return (
    <img
      src={`https://www.google.com/s2/favicons?domain=${encodeURIComponent(hostname)}&sz=32`}
      alt={`${name} favicon`}
      className={`shrink-0 ${className}`}
      onError={() => setHasError(true)}
    />
  )
}
